import React from "react";
import Header from "./Header";

const ProductShowcase = ({ productData }) => {
  return (
    <>
      <div className="relative font-['Parkinsans']">
        <img
          src="/assets/utpannProduction/Bgcolor.png"
          alt="background"
          className="absolute top-0 right-0 w-[58%] h-[560px] md:h-[700px] lg:h-[1120px] object-cover z-[-1]"
        />

        <Header />

        <div className="p-[20px] md:pr-[66px] font-sans">
          {/* items-start zaroori hai sticky ke kaam karne ke liye */}
          <div className="flex flex-col md:flex-row gap-10 items-start">
            {/* Left Section: Image Area (Sticky) */}
            <div className="w-full md:w-1/2 md:sticky md:top-10 flex flex-col items-center">
              <div className="relative">
                <img
                  src={productData.image}
                  alt={productData.title}
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>

            {/* Right Section: Content Area (Scrollable) */}
            <div className="w-full md:w-1/2">
              <span className="text-gray-600 text-[20px] md:text-[24px] font-medium tracking-wide">
                {productData.category}
              </span>

              <h1 className="text-[30px] md:text-[40px] 2xl:text-[60px] font-bold text-[#343163] mt-1 mb-4">
                {productData.title}
              </h1>

              <p className="text-[#343163] text-[20px] md:text-[24px] leading-relaxed mb-4 text-justify">
                {productData.description}
              </p>

              {/* <div className="flex items-baseline gap-2 mb-6">
              <span className="text-[20px] md:text-[30px] font-bold text-[#343163]">
                ₹ {productData.price}/- (Inc GST)
              </span>
              <span className="text-gray-400 text-[16px] md:text-[20px] ml-2">
                {productData.priceNote}
              </span>
            </div> */}

              {/* Recommended Tags */}
              <div className="mb-6">
                <h3 className="font-bold text-[#343163] text-[20px] md:text-[30px] mb-3">
                  Recommended For :
                </h3>
                <div className="flex flex-wrap gap-3">
                  {productData.recommendations.map((item, index) => (
                    <span
                      key={index}
                      className="px-6 py-1 border border-gray-400 rounded-full text-[20px] md:text-[24px] text-[#1B0E02]"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>

              {/* Technical Specifications */}
              <div className="mb-6">
                <h3 className="font-bold text-[#343163] tracking-wider inline-block pb-1 text-[20px] md:text-[30px]">
                  {productData.specsTitle} :
                </h3>
                <ul>
                  {productData.specs.map((spec, index) => (
                    <li
                      key={index}
                      className="flex items-start text-[#1B0E02] text-[20px] md:text-[24px]"
                    >
                      <span className="mr-2">•</span>
                      <span>
                        <strong>{spec.label}:</strong> {spec.value}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Packaging Options */}
              <div className="mb-6">
                <h3 className="font-bold text-[#343163] tracking-wider inline-block pb-1 text-[20px] md:text-[30px]">
                  Packaging Options :
                </h3>
                <ul>
                  {productData.packaging.map((pack, index) => (
                    <li
                      key={index}
                      className="flex items-start text-[#1B0E02] text-[20px] md:text-[24px]"
                    >
                      <span className="mr-2">•</span>
                      <span>
                        <strong>{pack.label}:</strong> {pack.value}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Key Benefits */}
              <div className="mb-6">
                <h3 className="font-bold text-[#343163] tracking-wider inline-block pb-1 text-[20px] md:text-[30px]">
                  Key Benefits :
                </h3>
                <ul className="space-y-2">
                  {productData.benefits.map((benefit, index) => (
                    <li
                      key={index}
                      className="flex items-start text-[#1B0E02] text-[20px] md:text-[24px]"
                    >
                      <span className="mr-2">•</span>
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="relative ">
        {/* Product Image Placeholder */}
        <img
          src="/assets/Product/Soil.png"
          alt={"Soil"}
          className="w-full h-auto object-contain"
        />
      </div>
    </>
  );
};

export default ProductShowcase;
